exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.responsive[data-v-1cdf2d94] {\n  width: 100%;\n  height: auto;\n}\nbutton.btn[data-v-1cdf2d94] {\n  padding: 0 !important;\n}\n.text-code[data-v-1cdf2d94] {\n  font-size: 25px;\n}\n.code-promotion .block-code[data-v-1cdf2d94] {\n  display: inline-block;\n  padding: 10px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  border: 1px dashed;\n.text-code {\n    -ms-flex-line-pack: center;\n        align-content: center;\n}\n}\nimg.filter[data-v-1cdf2d94] {\n  -webkit-filter: invert(49%) sepia(68%) saturate(2131%) hue-rotate(159deg) brightness(92%) contrast(101%);\n          filter: invert(49%) sepia(68%) saturate(2131%) hue-rotate(159deg) brightness(92%) contrast(101%);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-1cdf2d94","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/landingPage/LinemanPromotion.vue
// module id = 2479
// module chunks = 0